import React from "react";
import classes from "../components/Styles.module.css";
import HeroSection from "../components/HeroSection";
import PageContent from "../components/PageContent";
import Footer from "../components/Footer";
import { Component } from "react";
/* import Float from '../components/side_button'; */
import Floattwo from '../components/side_button2';
import BottomNav from "../components/bottom";
import G13Ads from "../components/g13ads";
import AdsterraAd from "../components/Adsterads";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <div className={classes.mainContainer}>
          {/* <G13Ads/> */}
          {/* <AdsterraAd/> */}
          <HeroSection />
        {/*   <Float/> */}
          <Floattwo/>
          <PageContent></PageContent>
          <Footer />
          <BottomNav />
        </div>
      </>
    );
  }
}

export default Home;
